import React from 'react';

export const handleSearch = (
  inputValue: string,
  setInputValue: React.Dispatch<React.SetStateAction<string>>,
  newValue: string
) => {
  if (newValue !== inputValue) {
    setInputValue(newValue);
  }
};
